// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../action-list';
import {getRetailerNames} from '../../../shared/repositories';

export const readRetailerNames = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getRetailerNames();

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/get-retailer-names.js